import axios from "axios";

class apiCall {
  tmParamsBase() {
    const api_url = process.env.VUE_APP_APIFULL_URL;

    const apiClient = axios.create({
      baseURL: api_url,
    });
    return apiClient.get("tmticx?randomadd=" + new Date().getTime());
  }
  tmParamsBaseADT() {
    const api_url = process.env.VUE_APP_API + 'apga/' + 'cache/' + 'adt/';

    const apiClient = axios.create({
      baseURL: api_url,
    });
    return apiClient.get("tmticx?randomadd=" + new Date().getTime());
  }
  report(report) {
    const api_url = report;

    const apiClient = axios.create({
      baseURL: api_url,
    });
    return apiClient.get();
  }
  tmStatsADT(year) {
    const api_url = process.env.VUE_APP_API + 'apga/' + 'cache/' + 'adt/';

    const apiClient = axios.create({
      baseURL: api_url,
    });
    return apiClient.get(
      year +
        "/tmticx?field=Y&fields=ooms&fields=stats&randomadd=" +
        new Date().getTime()
    );
  }
  statADT(year, stat) {
    const api_url = process.env.VUE_APP_API + 'apga/' + 'cache/' + 'adt/';

    const apiClient = axios.create({
      baseURL: api_url,
    });
    return apiClient.get(
      year + "/" + year + stat + ".json?randomadd=" + new Date().getTime()
    );
  }
  tmStats(year) {
    const api_url = process.env.VUE_APP_APIFULL_URL;

    const apiClient = axios.create({
      baseURL: api_url,
    });
    return apiClient.get(
      year +
        "/tmticx?field=Y&fields=ooms&fields=stats&randomadd=" +
        new Date().getTime()
    );
  }
  stat(year, stat) {
    const api_url = process.env.VUE_APP_APIFULL_URL;

    const apiClient = axios.create({
      baseURL: api_url,
    });
    return apiClient.get(
      year + "/" + year + stat + ".json?randomadd=" + new Date().getTime()
    );
  }
}

export default new apiCall();